'use client';

import { Phone, AlertCircle } from 'lucide-react';

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'https://api.autofrance.se/api';
const PHONE = '042-20 16 20';
const PHONE_TEL = '+4642201620';

interface Props {
  source: 'category_empty' | 'product_missing' | 'no_results';
  ktype?: number;
  categorySlug?: string;
  brandSlug?: string;
  vehicleName?: string;
  categoryName?: string;
}

export function PhoneCtaBanner({ source, ktype, categorySlug, brandSlug, vehicleName, categoryName }: Props) {
  const handleClick = () => {
    // Fire-and-forget — never block the tel: navigation.
    try {
      fetch(`${API_URL}/track/phone-cta`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source,
          ktype,
          category_slug: categorySlug,
          brand_slug: brandSlug,
          page_url: typeof window !== 'undefined' ? window.location.href : null,
        }),
        keepalive: true,
      }).catch(() => {});
    } catch {
      /* ignore */
    }
  };

  const headline = vehicleName
    ? `Vi har inte ${categoryName?.toLowerCase() || 'denna del'} för din ${vehicleName} i nätbutiken just nu`
    : `Vi hittar inte denna del i nätbutiken just nu`;

  return (
    <div className="my-6 rounded-2xl border-2 border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 p-5 sm:p-6 shadow-sm">
      <div className="flex items-start gap-4">
        <div className="shrink-0 h-12 w-12 rounded-xl bg-amber-100 flex items-center justify-center">
          <AlertCircle className="h-6 w-6 text-amber-700" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="font-heading text-xl sm:text-2xl font-bold text-gray-900 mb-2">
            {headline}
          </h2>
          <p className="text-sm sm:text-base text-gray-700 mb-4">
            Vi har <strong>400 000+ delar</strong> i lagret som inte alla syns online.
            Ring oss så hjälper vi dig hitta rätt del direkt — eller beställer hem den åt dig.
          </p>

          <a
            href={`tel:${PHONE_TEL}`}
            onClick={handleClick}
            className="inline-flex items-center justify-center gap-3 w-full sm:w-auto px-6 sm:px-8 py-4 rounded-xl bg-[#0055A4] hover:bg-[#0f2e5a] text-white text-lg font-semibold shadow-md hover:shadow-lg transition-all active:scale-[0.98]"
          >
            <Phone className="h-5 w-5" />
            Ring {PHONE}
          </a>

          <p className="text-xs text-gray-500 mt-3">
            Öppet mån–fre 09:00–16:00 · 30 dagars öppet köp · Specialister sedan 1988
          </p>
        </div>
      </div>
    </div>
  );
}
